import { ApolloQueryResult, useQuery } from '@apollo/client';
import {
  Flex,
  Heading,
  Image,
  Table,
  Tbody,
  Td,
  Text,
  Tr,
  Stack,
  VStack,
  useColorModeValue,
} from '@chakra-ui/react';
import React from 'react';
import { useParams } from 'react-router-dom';
import { CompanySection } from '~/components/molecules';

import { Query } from '~/generated';
import { showCompany } from '~/queries/job';
import { formatDatetime } from '~/utilities/formatDatetime';

const CompanyDetails: React.FC = () => {
  const backgroundColor = useColorModeValue('gray.800', 'white');

  const { id } = useParams<{ id: string }>();
  const { loading, data } = useQuery(showCompany, {
    variables: { id },
  }) as ApolloQueryResult<Pick<Query, 'company'>>;

  if (loading) return <div>loading...</div>;
  if (!data?.company) {
    return <div>Not found</div>;
  }

  const {
    businessDescription,
    corporatePhilosophy,
    employeesNumber,
    representative,
    foundedOn,
    headquartersAddress,
    offices,
    coverImage,
  } = data.company;

  return (
    <>
      <Stack px={{ base: 0, md: '10%', lg: '20%' }}>
        {coverImage && (
          <Image
            src={coverImage}
            fit="cover"
            objectPosition="center"
            w="100%"
            maxW={1280}
            maxH={720}
          />
        )}
      </Stack>
      <Flex px={{ base: '5%', md: '10%', lg: '20%' }} py={10}>
        <VStack alignItems="flex-start" spacing={10}>
          <CompanySection company={data.company} />

          <VStack as="section" alignItems="flex-start">
            <Heading
              fontSize="x-large"
              fontWeight="bold"
              color={backgroundColor}
            >
              事業内容
            </Heading>
            <Text whiteSpace="pre-wrap">{businessDescription}</Text>
          </VStack>

          <VStack as="section" alignItems="flex-start">
            <Heading
              fontSize="x-large"
              fontWeight="bold"
              color={backgroundColor}
            >
              企業理念
            </Heading>
            <Text whiteSpace="pre-wrap">{corporatePhilosophy}</Text>
          </VStack>

          <VStack as="section" alignItems="flex-start">
            <Heading
              fontSize="x-large"
              fontWeight="bold"
              color={backgroundColor}
            >
              会社概要
            </Heading>
            <Table variant="simple">
              <Tbody>
                <Tr>
                  <Td w="100px" borderWidth="0px" p={0}>
                    設立
                  </Td>
                  <Td borderWidth="0px">
                    {foundedOn ? formatDatetime(foundedOn, false) : '未設定'}
                  </Td>
                </Tr>
                <Tr>
                  <Td borderWidth="0px" p={0}>
                    社員数
                  </Td>
                  <Td borderWidth="0px">{employeesNumber}名</Td>
                </Tr>
                <Tr>
                  <Td borderWidth="0px" p={0}>
                    代表者
                  </Td>
                  <Td borderWidth="0px">{representative}</Td>
                </Tr>
                <Tr>
                  <Td borderWidth="0px" p={0}>
                    本社所在地
                  </Td>
                  <Td borderWidth="0px">{headquartersAddress}</Td>
                </Tr>
                <Tr>
                  <Td borderWidth="0px" p={0}>
                    事業所
                  </Td>
                  <Td borderWidth="0px">{offices}</Td>
                </Tr>
              </Tbody>
            </Table>
          </VStack>
        </VStack>
      </Flex>
    </>
  );
};

export default CompanyDetails;
